<template>
    <cadastro-simples-list
        endpoint="modalidade"
        rota-base="/admin/modalidade"
        titulo="MODALIDADES"
        titulo-singular="Modalidade"
        :colunas-extras='[{"campo":"descricao","label":"Descrição","tipo":"string"},{"campo":"ordem","label":"Ordem","tipo":"string"}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
